module.exports = __webpack_public_path__ + "img/KM.d87e1827.jpg";